import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerIdentificationModalComponent } from './historical-customer-identification-modal.component';
import { HistoricalCustomerIdentificationComponent } from './historical-customer-identification.component';

@NgModule({
    declarations: [
        HistoricalCustomerIdentificationComponent,
        HistoricalCustomerIdentificationModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerIdentificationComponent,
        HistoricalCustomerIdentificationModalComponent
    ]
})

export class HistoricalCustomerIdentificationModule {}
